import type { ColDef } from 'ag-grid-community';

const AG_RIGHT_ALIGNED_CELL = 'ag-right-aligned-cell';

/**
 * True when `cellClass` is a static string or string[] containing AG Grid's right-aligned class.
 * Function `cellClass` is not evaluated here (would require cell params); those columns are
 * treated as not right-aligned for editor `type` selection.
 */
export function agGridStaticCellClassIsRightAligned(cellClass: ColDef['cellClass']): boolean {
  if (typeof cellClass === 'string' || Array.isArray(cellClass)) {
    return cellClass.includes(AG_RIGHT_ALIGNED_CELL);
  }
  return false;
}
